import { Component, HostBinding, Input, inject } from '@angular/core';

import { DeviceService } from '@frontend/vanilla/core';

@Component({
    selector: 'ms-skeleton-grid',
    templateUrl: './skeleton-grid.component.html',
})
export class SkeletonGridComponent {
    device = inject(DeviceService);

    @HostBinding('class') className = 'sk-gird-container  sk-b-rad5';
    @Input() isHorseRaceForecast = false;

    teams = [
        { team1: 'team1', team2: 'team2' },
        { team1: 'team3', team2: 'team4' },
        { team1: 'team5', team2: 'team6' },
        { team1: 'team3', team2: 'team4' },
    ];

    get isMobileOrRacingForecast(): boolean {
        return this.isHorseRaceForecast || (this.device.isMobile && !this.device.isTablet);
    }
}
